// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"120e27ef","356":"07dad4e3","438":"c1dd7613","465":"7b7ec398","538":"50c4dd71","912":"6276f797","954":"855aa957"}[chunkId] + ".chunk.js";
};